import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const entityIconDefaultVariants = {
  "appearance": "default",
  "density": "default"
}
const entityIconCompoundVariants = []

const entityIconSlotNames = [
  [
    "root",
    "entity-icon__root"
  ]
]
const entityIconSlotFns = /* @__PURE__ */ entityIconSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, entityIconDefaultVariants, getSlotCompoundVariant(entityIconCompoundVariants, slotName))])

const entityIconFn = memo((props = {}) => {
  return Object.fromEntries(entityIconSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const entityIconVariantKeys = [
  "appearance",
  "density"
]
const getVariantProps = (variants) => ({ ...entityIconDefaultVariants, ...compact(variants) })

export const entityIcon = /* @__PURE__ */ Object.assign(entityIconFn, {
  __recipe__: false,
  __name__: 'entityIcon',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: entityIconVariantKeys,
  variantMap: {
  "appearance": [
    "default",
    "muted",
    "highlighted"
  ],
  "density": [
    "compact",
    "default",
    "large"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, entityIconVariantKeys)
  },
  getVariantProps
})